import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SET_SUMMARY_MESSAGE] (state, { message, hasExpand }) {
    console.log(types.SET_SUMMARY_MESSAGE, message, hasExpand)
    Vue.set(state, 'summaryMessage', message)
    Vue.set(state, 'expandBanner', hasExpand)
  },
  [types.TOGGLE_SUMMARY_MESSAGE] (state) {
    console.log(types.TOGGLE_SUMMARY_MESSAGE)
    Vue.set(state, 'expandBanner', !state.expandBanner)
  },
  [types.SET_VIEW_TITLE] (state, title) {
    console.log(types.SET_VIEW_TITLE, title)
    Vue.set(state, 'viewTitle', title)
  },
  [types.SET_CURRENT_KINO_ID] (state, id) {
    console.log(types.SET_CURRENT_KINO_ID, id)
    Vue.set(state, 'currentKinoId', id)
  },
  [types.SET_NOTIFICATION_COUNT] (state, id) {
    console.log(types.SET_NOTIFICATION_COUNT, id)
    Vue.set(state, 'notificationCount', id)
  },
  [types.SET_ADMIN_NOTIFICATION_COUNT] (state, id) {
    console.log(types.SET_ADMIN_NOTIFICATION_COUNT, id)
    Vue.set(state, 'adminNotificationCount', id)
  },
  [types.SET_SYSTEM_NOTIFICATION_COUNT] (state, id) {
    console.log(types.SET_SYSTEM_NOTIFICATION_COUNT, id)
    Vue.set(state, 'systemNotificationCount', id)
  },
  [types.SET_CAR_NOTIFICATION_COUNT] (state, id) {
    console.log(types.SET_CAR_NOTIFICATION_COUNT, id)
    Vue.set(state, 'carNotificationCount', id)
  },
  [types.SET_LICENCE_NOTIFICATION_COUNT] (state, id) {
    console.log(types.SET_LICENCE_NOTIFICATION_COUNT, id)
    Vue.set(state, 'licenceNotificationCount', id)
  }
}
